import React from 'react'
import { OmInput } from '@owma/kit'
import styles from './style.module.scss'

interface InputFieldProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  isQuarter?: boolean
  useTextArea?: boolean
}

function InputField({
  id,
  label,
  value,
  onChange,
  isQuarter,
  useTextArea = false,
}: InputFieldProps) {
  return (
    <div className={styles.inputField} style={isQuarter ? { width: '25%', flex: 'none' } : {}}>
      <label htmlFor={id}>{label}</label>
      {useTextArea ? (
        <OmInput
          id={id}
          className={styles.textareascrollbar}
          value={value}
          onChange={(value) => onChange(value)}
          multiline
          autoSize={{ minRows: 4, maxRows: 8 }}
        />
      ) : (
        <OmInput id={id} value={value} onChange={(value) => onChange(value)} />
      )}
    </div>
  )
}

export default InputField
